import React, { Component } from 'react';
import "./meetingImage.css";

class MeetingImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedActor: -1
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedActor: nextProps.data[nextProps.data.length - 1].fromActor
        })
    }

    render() {
        let { meetingActors, actorsList, selfActorId } = this.props;
        let { selectedActor } = this.state;

        let actorDetails = meetingActors.map(item => {
            return actorsList.find(actor => actor.id === parseInt(item))
        })
        let selfActor = actorsList.find(actor => actor.id === selfActorId)

        let colorFilterStyle = {
            filter: 'grayscale(100%)'
        };

        return (
            <div className="meeting-img">
                <div className="your-img">
                    <div className="your-img-box">
                        <img
                            className={
                                selectedActor === selfActor.id ?
                                    "your-img-style-ripple"
                                    : "your-img-style"
                            }
                            src={selfActor.gravatar}
                            style={selectedActor !== selfActor.id ? colorFilterStyle : {}}
                        />
                        <div>{selfActor.first_name}</div>
                    </div>
                </div>
                <div className="team-images">
                    <div className="team-img-box" >
                        <img
                            src={actorDetails[0].gravatar}
                            className={
                                selectedActor === actorDetails[0].id ?
                                    "team-img-style-ripple"
                                    : "team-img-style"
                            }
                            style={selectedActor !== actorDetails[0].id ? colorFilterStyle : {}}
                        />
                        {actorDetails[0].first_name}
                    </div>
                    <div className="team-img-box">
                        <img
                            src={actorDetails[1].gravatar}
                            className={
                                selectedActor === actorDetails[1].id ?
                                    "team-img-style-ripple"
                                    : "team-img-style"
                            }
                            style={selectedActor !== actorDetails[1].id ? colorFilterStyle : {}}
                        />
                        {actorDetails[1].first_name}
                    </div>
                    <div className="team-img-box">
                        <img
                            src={actorDetails[2].gravatar}
                            className={
                                selectedActor === actorDetails[2].id ?
                                    "team-img-style-ripple"
                                    : "team-img-style"
                            }
                            style={selectedActor !== actorDetails[2].id ? colorFilterStyle : {}}
                        />
                        {actorDetails[2].first_name}
                    </div>
                </div >
            </div>
        );
    }
}

export default MeetingImage;



// WEBPACK FOOTER //
// /src/call/meeting/meetingImage/meetingImage.js